import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=656631b3&scoped=true&lang=pug&"
import script from "./ButtonBase.vue?vue&type=script&lang=js&"
export * from "./ButtonBase.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=656631b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656631b3",
  null
  
)

export default component.exports